module.exports = __webpack_public_path__ + "static/img/IMG(1).393ae493.jpg";